import { FC } from 'react'
import { Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { Activity, ProcessedActivity } from '../../../../../api/models'
import { ActivityTypeDisplayNames } from '../../EngagementDetailsEnums'
import DownArrow from '../../../../../assets/images/drop-down-arrow.svg?react'
import { ActivityDurationButton } from './ActivityDurationButton'
import { ActivityTimingResult } from './useActivityTiming'

type UserGeneratedActivityHeaderProps = {
  processedActivity: ProcessedActivity
  isCollapsed: boolean
  timing: ActivityTimingResult
  activityTypeIndexOf?: string
  onSeek?: (timeInSeconds: number) => void
  onToggleCollapsed: () => void
}

function getActivityTypeDisplayName(activity: Activity) {
  return ActivityTypeDisplayNames[activity.type]
}

export const UserGeneratedActivityHeader: FC<UserGeneratedActivityHeaderProps> = ({
  processedActivity,
  isCollapsed,
  timing,
  activityTypeIndexOf,
  onSeek,
  onToggleCollapsed
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        gap: 'var(--spacing-s)',
        alignItems: 'center',
        paddingBottom: isCollapsed ? 'var(--spacing-none)' : 'var(--spacing-s)'
      }}
      data-testid={`activity-card-user-generated-${processedActivity.type}`}
    >
      <ActivityDurationButton
        isInteractive
        isScrubberWithinActivity={timing.isActive}
        durationMs={processedActivity.durationMillis}
        data-testid={`activity-card-play-tag-${processedActivity.type}`}
        onClick={() => {
          onSeek?.(processedActivity.relativeStartTimeSeconds)
        }}
      />
      <Typography sx={{ fontWeight: '700', flex: 1, display: 'flex', alignItems: 'center', gap: 'var(--spacing-2xs)' }}>
        {getActivityTypeDisplayName(processedActivity)}
        {activityTypeIndexOf && (
          <Box
            component="span"
            sx={{
              fontSize: 'var(--size-2xs)',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'var(--line-height-xs)',
              letterSpacing: 'var(--letter-spacing-xs)'
            }}
          >
            {activityTypeIndexOf}
          </Box>
        )}
      </Typography>
      <DownArrow
        width="var(--icons-m)"
        height="var(--icons-m)"
        onClick={onToggleCollapsed}
        style={{ transform: isCollapsed ? 'none' : 'rotate(180deg)', cursor: 'pointer' }}
        data-testid={`collapse-expand-button`}
      />
    </Stack>
  )
}
